import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute('/_authed/dashboard/reviews')({
  component: () => (
    <ComingSoonPage
      title="Reviews"
      description="Negative feedback first; ratings and Google routing behind it. Coming soon."
    />
  ),
});
